import React from 'react';

interface TopProgressBarProps {
  visible: boolean;
}

const TopProgressBar: React.FC<TopProgressBarProps> = ({ visible }) => {
  if (!visible) return null;

  return (
    <div className="w-full overflow-hidden" style={{ height: 2 }}>
      <div
        className="h-full bg-[#8A3033] rounded-full"
        style={{
          animation: 'topbar-slide 1.4s ease-in-out infinite',
          width: '40%',
        }}
      />
      <style>{`
        @keyframes topbar-slide {
          0%   { transform: translateX(-100%); }
          100% { transform: translateX(350%); }
        }
      `}</style>
    </div>
  );
};

export default TopProgressBar;
